module.exports = __webpack_public_path__ + "static/media/so-stock--cow1.a48ad0af.jpg";